import React from 'react';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';
import { Modal } from 'apps/modals/views/modal';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { ComponentRegistry } from 'core';
import { Trans } from 'react-i18next';
import { PhaseSelection } from 'apps/project/views/phaseSelection';
import { PhaseOption } from 'apps/project/views/phaseOption';

ComponentRegistry.add('project.phaseSelection', PhaseSelection);
ComponentRegistry.add('project.phaseOption', PhaseOption);

@observer
export class EditPhaseForm extends Modal {
  render() {
    const { editPhaseFormStore, SelectPhase } = modalStore.props.projectApp;
    const {
      conf: { formTitle },
    } = editPhaseFormStore;
    return (
      <>
        <ModalTitle level={2}>
          <Trans>{formTitle}</Trans>
        </ModalTitle>
        <Form
          formStore={editPhaseFormStore}
          formTitle=''
          buttonHandler={SelectPhase}
          noBorder={true}
          padding='0'
          responsive
        />
      </>
    );
  }
}
